<!-- eslint-disable -->
<template lang="pug">
    .box
        .box-body
            div(
                :class="{'detective-container_with-warning': isMobile && !isFullScreen}",
                v-if="!areSchoolsBlocked && !blockedAccesses.includes('fastReading')"
            )
                .warning(v-if="isMobile && !isFullScreen")
                    svg#rotate(version='1.1', xmlns='http://www.w3.org/2000/svg', x='0px', y='0px', width='40px', height='40px', viewBox='0 0 612 612', style='enable-background:new 0 0 612 612;', xml:space='preserve')
                        rotation-icon
                    div
                        | {{ $i18n.t('detective.detective_mobile_rotateText') }}
                detective-component(v-else :modal="modal")
            div.block-message(v-else) {{ $i18n.t('errors.page_not_access') }}
</template>

<script>
    /*eslint-disable*/
    import CsLoader from '../../../elements/CsLoader.vue'
    import courseAccesses from "../../../utils/user/courseAccesses"
    import MobileDetect from 'mobile-detect/mobile-detect.js'
    import RotationIcon from './detective-assets/RotationIcon.vue'
    import BillingBlockMixin from '../../../utils/user/BillingBlockMixin';
    import { mapState } from 'vuex'

    export default {
        mixins: [courseAccesses, BillingBlockMixin],
        props: {
            modal: Boolean,
        },
        created () {
            window.addEventListener('resize', this.getWindowDimensions);
            this.$nextTick(this.getWindowDimensions);
        },
        mounted () {
            if (!this.courseAllowDetective) {
                this.$router.push({ name: '403' });
            }
            let mobileDetect = new MobileDetect(window.navigator.userAgent);
            this.isMobile = Boolean(mobileDetect.phone() || mobileDetect.tablet());
        },
        beforeDestroy () {
            this.hideDetectiveFullScreen();
            window.removeEventListener('resize', this.getWindowDimensions);
        },
        data () {
            return {
                isMobile: false,
                windowWidth: 0,
                windowHeight: 0,
            }
        },
        watch: {
            isFullScreen (value) {
                if (!value && this.isMobile) {
                    this.hideDetectiveFullScreen();
                }
            }
        },
        methods: {
            getWindowDimensions () {
                this.windowWidth = document.documentElement.clientWidth;
                this.windowHeight = document.documentElement.clientHeight;
            },
            hideDetectiveFullScreen () {
                let sidebar = document.querySelector('.sidebar-column');
                if (sidebar) {
                    sidebar.classList.remove('is-hidden');
                }
                let header = document.querySelector('.app-header');
                if (header) {
                    header.classList.remove('is-hidden');
                }
                let mainColumn = document.querySelector('.main-column');
                if (mainColumn) {
                    mainColumn.classList.remove('is-fullscreen');
                }
            }
        },
        computed: {
            isFullScreen () {
                return this.windowWidth >= this.windowHeight;
            },
            ...mapState({
                user: state => state.auth.user,
            })
        },
        components: {
            DetectiveComponent: () => ({
                component: import('./DetectiveComponent.vue'),
                loading: CsLoader,
                delay: 0
            }),
            RotationIcon,
        }
    }
</script>

<style lang="scss" scoped>
    .box {
        width: 100%;
        padding: 0;
        border-radius: 40px;
        background: #FFFFFF;
        box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
        display: block;
        @media screen and (max-width: 568px) {
            border-radius: 0;
        }
    }
    .detective-container_with-warning {
        height: 100vh;
        width: 100%;
        display: table;
    }
    .warning {
        display: table-cell;
        vertical-align: middle;
        text-align: center;
    }
    .block-message {
        text-align: center;
        font-family: Boomboom, serif;
        color: #FFFFFF;
        font-size: 22px;
        white-space: nowrap;
        @include media($sm) {
            font-size: 48px;
        }
        @include media($lg) {
            font-size: 60px;
        }
    }
</style>
